import { ImageCloudUrl } from "api/api";

const CDN_IMAGE_BUCKET = "latviesi-media"; // ! TODO env
const NEXT_PUBLIC_IMAGE_CDN = ImageCloudUrl; // ! TODO env

export enum CDN_IMAGE_SIZE {
  THUMBNAIL = "450x220",
  LARGE_THUMBNAIL = "650x420",
  SQUARE_THUMBNAIL = "400x400",
  OPTIMIZED = "850x500",
  FULL_SIZE = "",
}

const ALLOWED_EXTENSIONS = ["jpg", "jpeg", "png"];

export default function getCDNImage(
  link?: string,
  size: CDN_IMAGE_SIZE | string = CDN_IMAGE_SIZE.FULL_SIZE,
) {
  // https://BUCKET.s3.REGION.amazonaws.com/FOLDER/NAME.EXTENSION
  if (!link) return undefined;
  if (!link.includes(CDN_IMAGE_BUCKET)) return link;
  const extension = link.split(".").pop();
  if (!ALLOWED_EXTENSIONS.some((v) => extension === v)) return link;

  const urlComponents = link.split("/");
  urlComponents.splice(0, 3);
  const imgKey = urlComponents.join("/");
  return `${NEXT_PUBLIC_IMAGE_CDN}/fit-in/${size}/filters:quality(85)/${imgKey}`;
}
